module.exports = __webpack_public_path__ + "img/logo.3b5b472b.png";